import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
  })

  return function onChange(value) {
    change(next => {
      next.treatment_id = value //treatment._id
      next.appointment_id = null
    })
  }
}
